<template>
  <div v-loading="loadingContract" style="min-height: 100px;">
    <div class="p-contract-content-wrap" @click="goContractDetail(item)" v-for="(item,index) in recentlyContractData" :key="index">
      <div class="p-icon ibass ibass-dot"></div>
      <div class="p-contract-content">
        <div class="p-contract-name" :title="item.contractName">{{item.contractName}}</div>
        <div class="p-contract-number p-text" v-if="item.contractNumber" :title="item.contractNumber">合同编号: {{item.contractNumber}}</div>
        <div class="p-contract-date p-text" v-if="item.signDate && item.endDate">合同期限: {{item.signDate}}-{{item.endDate}}
        </div>
      </div>
    </div>
    <div class="blankText" v-if="showContractText">暂无最近浏览合同</div>
  </div>
</template>

<script>
import indexService from '../../../service/index'
import timeUtils from '@/utils/time'
export default {
  name: 'RecentlyContract',
  data () {
    return {
      loadingContract: false,
      showContractText: false,
      recentlyContractData: []
    }
  },
  mounted () {
    this.getRecentlyContract()
  },
  methods: {
    goContractDetail (contract) {
      window.parent.postMessage({
        action: 'fromWorkFlatContractDetail',
        data: {
          contractId: contract.id,
          matterId: contract.matterId
        }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
      this.$analysis.track('查看最近浏览合同_最近浏览/工作台模块')
    },
    async getRecentlyContract () {
      this.loading = true
      try {
        const response = await indexService.getRecentlyContract()
        if (response.isSuccess) {
          if (response.data && response.data.length > 0) {
            response.data.map(item => {
              if (item.signDate) {
                item.signDate = timeUtils.formatTime(
                  new Date(item.signDate), 'days')
              }
              if (item.endDate) {
                item.endDate = timeUtils.formatTime(
                  new Date(item.endDate), 'days')
              }
            })
            this.recentlyContractData = response.data
            this.showContractText = false
          } else {
            this.showContractText = true
          }
          this.loadingContract = false
        } else {
          this.$postMessage.toast({ msg: response.message || response.resultMsg })
          this.loadingContract = false
        }
      } catch (e) {
        this.loadingContract = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .p-contract-content-wrap {
    display flex;
    width 100%;
    .p-icon {
      color #C4C4C4;
      padding-top 3px;
    }
    .p-contract-content {
      width calc(100% - 30px)
      margin-left 14px;
      box-sizing border-box;
      padding-bottom 14px;
      border-bottom 1px solid #f1f2f3;
      margin-bottom 10px;

      .p-contract-name {
        font-size 14px;
        color #000000;
        margin-bottom 8px;
        text-overflow ellipsis;
        white-space nowrap;
        overflow hidden;
        cursor: pointer;
      }
      .p-contract-number {
        margin-bottom 5px;
      }
      .p-text {
        font-size 12px;
        color #8590A6;
        text-overflow ellipsis;
        white-space nowrap;
        overflow hidden;
        cursor: pointer;
      }
    }
  }

  .blankText {
    font-size 14px;
    text-align center;
    margin-top 30px;
    color #8c939d;
  }
</style>
